module.exports = __webpack_public_path__ + "static/gem-visa-bg-desktop-0426c86fc99d8c79873fcf2b2327a350.jpg";